import React, { useEffect, useState } from "react";
import api, { imgUrl } from "../lib/api";

let cached = null;
let pending = null;
const loadLogo = () => {
  if (cached !== null) return Promise.resolve(cached);
  if (!pending) pending = api.get("/config").then((r) => { cached = r.data?.app_logo || ""; return cached; }).catch(() => (cached = ""));
  return pending;
};

// App logo from admin settings (app_logo) with static /logo.png fallback.
export function BrandLogo({ className = "w-9 h-9 rounded-xl", alt = "Royal Lakshmi", testId = "brand-logo" }) {
  const [src, setSrc] = useState(cached ? imgUrl(cached) : "/logo.png");
  useEffect(() => { loadLogo().then((p) => { if (p) setSrc(imgUrl(p)); }); }, []);
  return <img src={src} alt={alt} className={className} data-testid={testId} onError={(e) => { e.currentTarget.src = "/logo.png"; }} />;
}
